import logo from "../../img/logo.png";
import { Link } from "react-router-dom";

const Header = (props) => {
    return (
        <div className="container m-0 p-0" style={{overflowX: "hidden"}}>
            <div className="header-bg">
                <div className="row mb-4 pt-2 pb-5">
                    <div className="offset-md-3 col-md-6 text-center">
                        <Link to="/">
                            <img className="img-fluid" src={logo} alt="img" style={{ maxWidth: '300px', height: 'auto' }} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;